import { TOKEN, apiUrl } from "../Constants"
import api from "./ApiService"
import { Stack } from "@mui/material"

const BASE_URL_PDPA = apiUrl + "/api/pdpa"
const BASE_URL_PDPAUser = apiUrl + "/api/pdpaUser"

export interface iPdpaReq {
  pdpaName: string
  activeDate: string
  expirationDate: string
  is_active: boolean
  thaiContent?: string
  englishContent?: string
  version: string
  created_by?: string
  modified_by?: string
}

enum PDPAActionType {
  CreateProfile = "CreateProfile",
  ApplyJob = "ApplyJob",
  SignContact = "SignContact",
  SubmitProfile = "SubmitProfile",
}

interface iPDPAUser {
  pdpaVersionId: string
  userId: string
  actionType: PDPAActionType
  created_by: string
}

export function acticePDPAVersion() {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }
  return api.get(`${BASE_URL_PDPA}/getStatus`, config)
}

export function addPDPAVersion(data: iPdpaReq) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }
  return api.post(`${BASE_URL_PDPA}/`, data, config)
}

export function updatePDPAVersion(id: string, data: iPdpaReq) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.put(`${BASE_URL_PDPA}/${id}`, data, config)
}

export function getPDPAVersionById(id: string) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.get(`${BASE_URL_PDPA}/${id}`, config)
}

export function getAllPDPA() {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.get(`${BASE_URL_PDPA}/`, config)
}

export function getPDPAByStatus(status: string) {
  // const config = {
  //   headers: { Authorization: `Bearer ${TOKEN}` },
  // }

  return api.get(`${BASE_URL_PDPA}/status/${status}`)
}

//PDPA map User

export function addPDPAUserData(data: iPDPAUser) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }
  return api.post(`${BASE_URL_PDPAUser}/`, data, config)
}

export function updatePDPAUserFile(id: string, data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.put(`${BASE_URL_PDPAUser}/${id}`, data, config)
}

export function getPDPAUserFileById(id: string) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.get(`${BASE_URL_PDPAUser}/${id}`, config)
}

export function getAllPDPAUserFile() {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.get(`${BASE_URL_PDPAUser}/`, config)
}

export function getPDPAUserPagingData(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }
  return api.post(`${BASE_URL_PDPAUser}/get-pdpa-user/paging`, data, config)
}


